import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/contratos';

// ------- SAGA ------ //

function contratosCorrecto(state, action) {
    const { responseContratos } = action.payload;
    state.response = responseContratos;
    state.responseError = false;
}

function cotnratosError(state){
    state.response = [];
    state.responseError = true;
}


const contratos = createAction('contratos');


const contratosReducer = createSlice({
  name: 'contratos',
  initialState,
  reducers: {
    contratosCorrecto,
    cotnratosError
  },
});

export const contratosActions = {
  ...contratosReducer.actions,
  contratos
};

export default contratosReducer.reducer;